// extracted by mini-css-extract-plugin
module.exports = {"devicesBox":"devices_devicesBox__1kz0v"};